const getters = {
  // for test
  originalState(state) {
    return state
  },
}

export default getters
